import { useUser } from '../context/UserContext';

/**
 * Хук для получения текстов интерфейса из конфигурации
 */
export const useUIText = () => {
    const { config } = useUser();
    return config?.uiText || {};
};

/**
 * Хук для получения констант приложения из конфигурации
 */
export const useAppConstants = () => {
    const { config } = useUser();
    return config?.appConstants || {};
};

/**
 * Хук для получения всей конфигурации
 */
export const useConfig = () => {
    const { config } = useUser();
    return config || {};
};
